import React from "react";
import "./active.scss";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { TiMessages } from "react-icons/ti";
import { useState } from "react";
import moment from "moment";

function Active({ show, onHide, saveButton, exp, alert, initValue, setstatusMember, setdiscountMember }) {
  const [sehari, setSehari] = useState(false)
  const [seminggu, setSeminggu] = useState(false)
  const [empatBelas, setEmpatBelas] = useState(false)
  const [tigaMinngu, setTigaMinggu] = useState(false)
  const [empatMinggu, setEmpatMinggu] = useState(false)
  const [tigaPuluh, setTigaPuluh] = useState(false)
  const [sembilanPuluh, setSembilanPuluh] = useState(false)
  const [setahun, setSetahun] = useState(false)
  const [valRadio, setValRadio] = useState()
  const [duaBleasMinngu, setDuaBelasMinggu] = useState(false)
  const [commonMember, setcommonMember] = useState(true)
  const [exclusiveMember, setexclusiveMember] = useState(false)

  return (
    <div
      id={show ? "show-modal" : "close-modal"}
      style={{
        width: "100vw",
        margin: "0",
        height: "100vh",
        position: "fixed",
      }}
    >
      <Modal.Dialog id="body-modalUmum">
        <Modal.Header onClick={onHide} id="header-body">
          <Modal.Title>
            <TiMessages color="#FFD700" fontSize="35px" /> AMO Message
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p className="fw-bold fs-5">Member Activation ?</p>

          <div>
            <div className="d-flex mt-3">
              <div class="form-check">
                  <input class="form-check-input" type="checkbox" value="common member" id="flexCheckDefault" 
                  checked={commonMember}
                  onClick={()=>{
                    setexclusiveMember(false)
                    setcommonMember(true)
                  }}
                  onChange={(e)=>setstatusMember(e.target.value)}
                  />
                  <label class="form-check-label" for="flexCheckDefault">
                    Common Member
                  </label>
                </div>
                <div class="form-check ms-3">
                  <input class="form-check-input" type="checkbox" value="exclusive member" id="flexCheckChecked" 
                  checked={exclusiveMember} 
                  onClick={()=>{
                    setexclusiveMember(true)
                    setcommonMember(false)
                  }}
                  onChange={(e)=>setstatusMember(e.target.value)}
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    Exclusive Member
                  </label>
                </div>
            </div>
            {
              exclusiveMember &&
              <span className="mt-1">
                  <label className="fw-bold">Discount</label>
                  <input type="text" className="form-control "
                  onChange={(e)=>setdiscountMember(e.target.value)}
                  style={{ width: "450px" }}/>
              </span>
            }
          </div>
        </Modal.Body>
        <div className="mb-3 mx-3">
          <label className="fw-bold">Expired</label>
          <input type="date" className="form-control "
          value={initValue}
          onChange={(e)=>exp(e.target.value)}
          style={{ width: "450px" }}/>

          {alert && (
              <p className="fw-bold text-danger" style={{ fontSize: "15px" }}>
                Alert : Enter expiration date
              </p>
            )}
        </div>

        <Form className="mb-3 ms-4">
          {['checkbox'].map((type) => (
            <div key={`inline-${type}`} className="mb-3">
              <Form.Check
                inline
                label="1 day"
                value={1}
                name="group1"
                checked={sehari}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(1)
                  setSehari(true)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(1, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="1 Weeks"
                value={7}
                name="group1"
                checked={seminggu}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(7)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSeminggu(true)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(7, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="2 Weeks"
                value={14}
                name="group1"
                type={type}
                checked={empatBelas}
                id={`inline-${type}-2`}
                onClick={()=>{
                  setValRadio(14)
                  setSehari(false)
                  setEmpatBelas(true)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(14, 'days').parseZone().format('YYYY-MM-DD'))
                }}
                  
              />

              <Form.Check
                inline
                label="3 Weeks"
                value={21}
                name="group1"
                checked={tigaMinngu}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(21)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSeminggu(false)
                  setTigaMinggu(true)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(21, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="4 Weeks"
                value={28}
                name="group1"
                checked={empatMinggu}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(28)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(true)
                  setDuaBelasMinggu(false)
                  exp(moment().add(28, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="12 Weeks"
                value={84}
                name="group1"
                checked={duaBleasMinngu}
                type={type}
                id={`inline-${type}-1`}
                onClick={()=>{
                  setValRadio(28)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(true)
                  exp(moment().add(84, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="1 Month"
                value={30}
                type={type}
                checked={tigaPuluh}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(30)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(true)
                  setSembilanPuluh(false)
                  setSetahun(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(30, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="3 Month"
                value={90}
                type={type}
                checked={sembilanPuluh}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(90)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(true)
                  setSetahun(false)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(90, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />

              <Form.Check
                inline
                label="1 year"
                value={365}
                type={type}
                checked={setahun}
                id={`inline-${type}-3`}
                onClick={()=>{
                  setValRadio(365)
                  setSehari(false)
                  setEmpatBelas(false)
                  setTigaPuluh(false)
                  setSembilanPuluh(false)
                  setSetahun(true)
                  setSeminggu(false)
                  setTigaMinggu(false)
                  setEmpatMinggu(false)
                  setDuaBelasMinggu(false)
                  exp(moment().add(365, 'days').parseZone().format('YYYY-MM-DD'))
                }}
              />
            </div>
          ))}
        </Form>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={onHide}
            style={{ background: "#262626" }}
          >
            Cancel
          </Button>
          <Button
            variant="warning"
            onClick={saveButton}
            style={{ color: "black" }}
          >
            Save changes
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </div>
  );
}

export default Active;
